<template>
    <div id="search_results">
        <div class="mb-3 text-right sort-buttons">
            <a :class="(sortMethod == 'Relevance') ? sortActiveClass : sortInactiveClass" @click="sortMethod = 'Relevance'">relevance</a>
            <a :class="(sortMethod == 'Date') ? sortActiveClass : sortInactiveClass" @click="sortMethod = 'Date'">date (newest first)</a>
            <a :class="(sortMethod == 'Alphabetically') ? sortActiveClass : sortInactiveClass" @click="sortMethod = 'Alphabetically'">alphabetically</a>
        </div>
        <hr>
        <div v-for="(result, index) in paginatedResults" :class="{'result light-blue': index % 2 === 0, 'result dark-blue': index % 2 !== 0 }">

            <div class="row name">
                <div v-if="result.type == 'page'" class="col">
                    <a :href="$basePath + '/' + result.slug">{{ result.name }}</a>
                </div>
                <div v-else-if="result.type == 'article'" class="col">
                    <a :href="$basePath + '/resources/news-updates/'+ result.slug">{{ result.name }}</a>
                </div>
                <div v-else-if="result.type == 'pdf'" class="col">
                    <img width="17" height="17" :src="$basePath + '/images/pdf.png'" alt="File PDF document">
                    <a :href="$basePath + '/uploads/'+ result.slug" target="_blank">{{ result.name }}</a>
                </div>
                <div v-else-if="result.type == 'material'" class="col">
                    <img width="19" height="19" :src="$basePath + '/images/document_icon.png'" alt="Tips & Materials document">
                    <a v-if="result.is_video"
                        :href="'#'+result.main_link_url" 
                        @click="showVideo(result.main_link)"
                        data-toggle="modal"
                        data-target="#video-modal"
                    >
                        {{ result.name }}
                    </a>
                    <a v-else :href="result.main_link" target="_blank">{{ result.name }}</a>
                </div>
            </div><!-- .name -->

            <div v-if="result.teaser" class="row teaser">
                <div class="col">
                    {{ result.teaser }}
                </div>
            </div><!-- .teaser -->

            <div v-if="result.type == 'material'" class="row teaser">
                <div class="col">
                    by {{ result.source_name }} — last modified {{ result.human_date }}
                </div>
            </div><!-- .teaser -->

            <div class="row location">
                <div v-if="result.type == 'page'" class="col">
                    Located in {{ result.title }}
                </div>
                <div v-else-if="result.type == 'article'" class="col">
                    Located in WHY GO NAPSACC /&nbsp;<a :href="$basePath + '/resources//news-updates'">News & Testimonials</a>
                </div>
                <div v-else-if="result.type == 'pdf'" class="col">
                    Located in WHAT WE DO /&nbsp;<a :href="$basePath + '/self-assessment-materials'">Self-assessments</a>
                </div>
                <div v-else-if="result.type == 'material'" class="col">
                    Located in <a :href="$basePath + '/tips-and-materials'">Tips & Materials</a>
                </div>
            </div><!-- .location -->

            <hr>
        </div>
        <div class="mt-4">
            <a v-if="pageNumber > 1" class="btn btn-orange-blue text-white page-number" @click="prevPage">&laquo; Previous 10 items</a>
            <span v-for="n in pageCount" class="mr-1">
                <a :class="(classPage == n) ? pageActiveClass : pageInactiveClass" @click="setPage(n)">{{ n }}</a>
            </span>
            <span v-if="classPage < pageCount - 1">
                <a class="btn btn-orange-blue text-white page-number next-items" @click="nextPage">Next 10 items  &raquo;</a>
            </span>
            <span v-else-if="classPage < pageCount && remainderResults != 0">
                <a class="btn btn-orange-blue text-white page-number next-items" @click="nextPage">Next {{ remainderResults }} items  &raquo;</a>
            </span>
        </div>
    </div>
</template>


<style lang="scss">
@import "../../sass/variables";
@import "../../sass/pages/search_public";
</style>


<script>
    import VideoModal from './materials/VideoModal.vue'
    import { mapWritableState } from 'pinia'
    import { useMaterialsStore } from './materials/store';

    export default {

        data() {
            return {
                sortActiveClass: 'btn btn-blue-blue text-white sort',
                sortInactiveClass: 'btn btn-orange-blue text-white sort',
                pageActiveClass: 'btn btn-blue-blue text-white page-number',
                pageInactiveClass: 'btn btn-orange-blue text-white page-number',
                sortMethod: 'Relevance',
                index: 0,
                pageNumber: 1,
                size: 10,
                classPage: 1,
                showVideoModal: false
            }
        },

        props: ['results'],

        components: {
            VideoModal
        },

        methods: {
            nextPage(){
                this.pageNumber++
                this.index++
                this.classPage++
            },
            prevPage(){
                this.pageNumber--
                this.index--
                this.classPage--
            },
            setPage(n) {
                this.pageNumber = n
                this.index = n - 1
                this.classPage = n
            },
            showVideo(video) {
                this.showVideoModal = true;
                this.currentVideo = JSON.parse(video)
            }
        },

        computed: {
            sortedResults: function() {
                if (this.sortMethod == 'Relevance') {
                    this.index = 0
                    return this.results.sort((a, b) => b.relevance - a.relevance)
                }
                if (this.sortMethod == 'Date') {
                    this.index = 0
                    return this.results.sort((a, b) => new Date(b.date) - new Date(a.date))
                }
                if (this.sortMethod == 'Alphabetically') {
                    this.index = 0
                    return this.results.sort( function(a, b) {
                        return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
                    })
                }
            },
            pageCount(){
                let l = this.results.length,
                    s = this.size;
                return Math.ceil(l/s);
            },
            remainderResults(){
                let l = this.results.length,
                    s = this.size;
                return l % s
            },
            paginatedResults(){
                let start = this.index * this.size,
                      end = start + this.size;
                return this.sortedResults.slice(start, end)
            },
            ...mapWritableState(useMaterialsStore, {
                currentVideo: 'video'
            }),
        },
        mounted() {
            useMaterialsStore();
        }
    }
</script>